/** Organization datagrid key base — full key is `${WORK_SHIFTS_DATAGRID_KEY}_${organizationId}` */
export const WORK_SHIFTS_DATAGRID_KEY = "organization_work_shifts_grid";

export const WORK_SHIFT_DEFAULT_COLUMNS = [
  {
    field: "work_shift_name",
    label: "Work Shift Name",
    visible: true,
    width: 200,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "work_shift_start_time",
    label: "Start Time",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "work_shift_end_time",
    label: "End Time",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "break_duration_minutes",
    label: "Break Duration (Minutes)",
    visible: true,
    width: 180,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "work_duration_minutes",
    label: "Work Duration",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "is_active",
    label: "Is Active",
    visible: true,
    width: 120,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "location",
    label: "Location",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
  {
    field: "work_shift_type",
    label: "Work Shift Type",
    visible: true,
    width: 150,
    filterable: true,
    sortable: true,
    pinned: "none",
    required: false,
  },
];

export const WORK_SHIFT_PERSONALIZE_CONFIG = {
  defaultVisibleColumns: WORK_SHIFT_DEFAULT_COLUMNS.map((col) => col.field),
  columnLabels: Object.fromEntries(
    WORK_SHIFT_DEFAULT_COLUMNS.map((col) => [col.field, col.label])
  ),
  columnWidths: Object.fromEntries(
    WORK_SHIFT_DEFAULT_COLUMNS.map((col) => [col.field, col.width])
  ),
};

export const WORK_SHIFT_PERSONALIZE_COLUMN_KEYS =
  WORK_SHIFT_DEFAULT_COLUMNS.map((col) => col.field);

const COLUMN_FIELD_ALIASES = {
  shift_type: "work_shift_type",
  work_shift_type_name: "work_shift_type",
  location_name: "location",
};

export function normalizeWorkShiftColumnField(field) {
  const raw = String(field || "").trim();
  if (!raw) return raw;
  if (COLUMN_FIELD_ALIASES[raw]) return COLUMN_FIELD_ALIASES[raw];
  const lower = raw.toLowerCase();
  return COLUMN_FIELD_ALIASES[lower] || raw;
}

export function resolveWorkShiftApiField(field) {
  return normalizeWorkShiftColumnField(field);
}

export function mapSavedWorkShiftColumns(savedColumns = []) {
  const labelByField = WORK_SHIFT_PERSONALIZE_CONFIG.columnLabels || {};

  return savedColumns
    .map((col) => {
      const field = normalizeWorkShiftColumnField(col.field || col.key);
      if (!field || field === "organization_work_shift_id") return null;

      const defaultCol = WORK_SHIFT_DEFAULT_COLUMNS.find(
        (c) => c.field === field
      );

      return {
        ...(defaultCol || {}),
        ...col,
        field,
        key: field,
        label: col.label || labelByField[field] || field,
        visible: col.visible !== false,
        filterable: col.filterable !== false,
        sortable: col.sortable !== false,
      };
    })
    .filter(Boolean);
}
